export interface TimeZone {
    ID:                               number;
    NameFr:                           string;
    NameEn:                           string;
    StandardTimeAbbreviationFr:       string;
    StandardTimeAbbreviationEn:       string;
    StandardTimeOffsetHour:           number;
    DaylightSavingTimeAbbreviationFr: string;
    DaylightSavingTimeAbbreviationEn: string;
    DaylightSavingTimeOffsetHour:     number;
    TZDatabaseID:                     string;
    WindowsTimezoneID:                string;
}